import Lockr from 'lockr'
import Vue from 'vue'
import _ from 'lodash'
Lockr.prefix = 'lock_menu_'
export default {
  setUserinfo (state, userinfo) {
    state.userinfo = userinfo
    Lockr.set('userinfo', userinfo)
  },
  emitLoading (state) {
    state.fullscreenLoading = true
  },
  removeLoading (state, duration = 0) {
    setTimeout(() => {
      state.fullscreenLoading = false
    }, duration)
  },
  setCanteenList (state, canteenList) {
    let faceCanteenList = state.faceCanteenList
    canteenList.forEach(a => {
      let tar = _.find(faceCanteenList, b => a.canteen_name === b.canteen_name)
      console.log(tar)
      if (tar) {
        Vue.set(a, 'canteen-api-key', tar['canteen-api-key'])
      }
    })
    // console.log(canteenList)
    state.canteenList = canteenList
    Lockr.set('canteenList', canteenList)
  },
  clearUserInfo (state) {
    Vue.set(state, 'userinfo', {
      api_key: '',
      username: '',
      eatery_id: '',
      phoneNum: 0
    })
    Vue.set(state, 'canteenList', [])
    Lockr.set('userinfo', null)
    console.log(Lockr.get('userinfo'))
  },
  setFaceCanteenList (state, list) {
    state.faceCanteenList = list
  }
}
